<script>
import { SancareSticky } from '@sancare/typescript-commons'
import _ from 'lodash'

import { ModeEnum } from '../store/modules/settings/types'

export default {
  components: {
    'sancare-sticky': SancareSticky,
  },
  props: {
    mode: { type: String, required: true },
    rums: { type: Array, required: true },
    displayedRumId: { type: Number, required: true },
    // Only meaningful in automation mode : which rum the active preview (AI or rules) says is
    // major. There is no persisted automation-mode major rum to fall back on (see
    // StayDisplayerPage.vue's buildRssDiagnosisGroupPreview) — outside automation mode this is
    // always null and standardModeMajorRum is used instead.
    automationMajorRumId: { type: Number, default: null },
  },
  emits: ['select-rum'],
  computed: {
    majorRum() {
      if (this.mode === ModeEnum.AUTOMATION) {
        return _.find(this.rums, (rum) => rum.id === this.automationMajorRumId) ?? { id: -1 }
      }

      return _.find(this.rums, (rum) => rum.standardModeMajorRum) ?? { id: -1 }
    }
  },
  methods: {
    selectRum(rumId) {
      this.$emit('select-rum', rumId)
    },
  },
}
</script>

<template>
  <sancare-sticky class="rum-selector-container">
    <div
      v-if="rums.length > 1"
      :class="{active: 0 === displayedRumId}"
      class="rum-selector center aligned"
      @click="selectRum(0)"
    >
      <div>RSS</div>
    </div>
    <div
      v-for="(rum, idx) in rums"
      :key="rum.id"
    >
      <div
        v-if="rum.id > 0"
        :class="{active: rum.id === displayedRumId}"
        class="rum-selector center aligned"
        @click="selectRum(rum.id)"
      >
        <div class="number">
          {{ idx + 1 }}{{ rum.id === majorRum.id ? '*' : '' }}
        </div>
        <div>RUM</div>
      </div>
    </div>
  </sancare-sticky>
</template>
